import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Placement } from './placement';
export { Placement };
import { placementSchema } from '@schemas/business-objects/placement';
import { CandidateFormGroup } from './candidate-form-group';
import { PositionFormGroup } from './position-form-group';

export class PlacementFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    startDate: SchemaFormControl;
    endDate: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
    positionId: SchemaFormControl;
    position: PositionFormGroup;
  };

  declare value: Partial<Placement>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(placementSchema, Placement, data, options);
  }

  get object(): Placement {
    return new Placement(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      case 'position':
        return new PositionFormGroup();
      default:
        return undefined;
    }
  }
}

export class PlacementFormArray extends PersistedFormArray {
  readonly entityName = 'Placement' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(placementSchema, Placement, options);
  }

  protected override createItemGroup() {
    return new PlacementFormGroup();
  }

  get array(): Placement[] {
    return this.controls.map((group: PlacementFormGroup) => group.object);
  }
}

export class PlacementPersistedArray extends PersistedArray<Placement> {
  readonly entityName = 'Placement' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Placement, options);
  }
}
